import React from "react";
import './NoWidgetsConfigured.css'
import Icon from "../../dashboard/Icon/Icon";

const NoWidgetsConfigured = () => {
  return (
    <div
      className="no-widgets-message"
      style={{ textAlign: "center", padding: "20px", fontSize: "18px" }}
    >
      <Icon
        src={"assets/icons/no_widgets_available.svg"}
        alt="icon"
        isWidgetIcon={false}
      />
     <span className="ng_h_4_r">No homepage assigned to this team</span>
    </div>
  );
};

export default NoWidgetsConfigured;
